import { store } from 'index';
import { navbarDropdowns } from 'utils/constants'

const handleNBClick = (val: string) => {

    const state           = store.getState();
    const componentsState = state.components;
    const page            = state.page.page;

    if (page === val) {
      if (componentsState.showAppIntro) {
        import("functions/actions/close_app_intro").then(func => {
          func.closeAppIntro();
        });
        return;
      }
      else if(val === 'content') {
        import("functions/navbar/navbar_click").then(func => {
          func.navBarClick('content');
        });
        return;
      }
    }

    if (val ===  'puzzles') {
     import("functions/navbar/navbar_click").then(func => {
      func.navBarClick('puzzles');
     });
     return;
    }

    if (val === 'contact us') {
      import("functions/modal/open_modal").then(openModal => {
        openModal.handleOpenModal('contact us')
      });
     return;
    }

    if (navbarDropdowns.includes(val)) {
     return;
    }
    
    import("functions/navbar/navbar_click").then(func => {
      func.navBarClick(val);
    });
 }

export default handleNBClick;